import { css } from 'emotion';

import getFontStyles from '../../../../../lib/styles/getFontStyles';
import getLineClampStyles from '../../../../../lib/styles/getLineClampStyles';
import getMainEpisodeListImageSize from '../../../../../lib/styles/getMainEpisodeListImageSize';

import { TPADeviceType } from '@wix/podcasts-common/dist/tpa';
import {
  LINES_ALLOWED,
  MOBILE_LINES_ALLOWED,
  LINE_HEIGHT,
  FIXED_FONT_SIZE,
} from '../../../../../lib/styles/dynamicStyleConstants';

export default function getStyles({ colors, fonts, settings, deviceType }) {
  const episodeTitle = css({
    color: colors.episodeTitleColor,
    ...getFontStyles(fonts.episodeTitleFont, {
      lineHeight: LINE_HEIGHT.TITLE,
    }),
    ...{
      [TPADeviceType.MOBILE]: {
        fontSize: 16,
      },
    }[deviceType],
    ...getLineClampStyles(
      deviceType === TPADeviceType.MOBILE
        ? { size: 16 }
        : fonts.episodeTitleFont,
      LINE_HEIGHT.TITLE,
      deviceType === TPADeviceType.MOBILE
        ? MOBILE_LINES_ALLOWED.MAIN_EPISODE_TITLE
        : LINES_ALLOWED.MAIN_EPISODE_TITLE,
    ),
  });

  return {
    episode: css({
      '&:after': {
        color: colors.episodeDescriptionColor,
      },
      [`&:hover .${episodeTitle}, &:active .${episodeTitle}`]: {
        color: colors.episodeButtonColor,
      },
    }),
    episodeTitle,
    episodeDescription: css({
      color: colors.episodeDescriptionColor,
      ...getFontStyles(fonts.episodeDescriptionFont),
      ...{
        [TPADeviceType.MOBILE]: {
          fontSize: 14,
        },
      }[deviceType],
      ...getLineClampStyles(
        deviceType === TPADeviceType.MOBILE
          ? { size: 14 }
          : fonts.episodeDescriptionFont,
        LINE_HEIGHT.DEFAULT,
        LINES_ALLOWED.MAIN_EPISODE_DESCRIPTION,
      ),
    }),
    episodeLabel: css({
      borderColor: colors.episodeDescriptionColor,
      color: colors.episodeDescriptionColor,
      ...getFontStyles(fonts.episodeDescriptionFont, {
        fontSize: FIXED_FONT_SIZE.EPISODE_LABEL,
      }),
    }),
    episodeMetaInfo: css({
      color: colors.episodeDescriptionColor,
      ...getFontStyles(fonts.episodeDescriptionFont),
      ...{
        [TPADeviceType.DESKTOP]: {
          fontSize: FIXED_FONT_SIZE.META_INFO,
        },
        [TPADeviceType.MOBILE]: {
          fontSize: 12,
          lineHeight: '12px',
        },
      }[deviceType],
    }),
    episodeDivider: css({
      height:
        deviceType === TPADeviceType.DESKTOP
          ? `${settings.dividerWidth}px`
          : '1px',
      backgroundColor: colors.dividerOpacityColor,
      margin:
        deviceType === TPADeviceType.DESKTOP
          ? `${settings.episodeListSpacing}px 0`
          : '18px 0',
    }),
    rightArr: css({
      backgroundColor: colors.episodeDescriptionColor,
    }),
    imageContainer: css({
      ...{
        [TPADeviceType.DESKTOP]: {
          width: getMainEpisodeListImageSize(fonts),
          height: getMainEpisodeListImageSize(fonts),
        },
      }[deviceType],
    }),
  };
}
